import React from 'react';
import PropTypes from 'prop-types';

import PlanePlanTableItem from './PlanePlanTableItem';

const PlanePlanTable = ({
  tableId, flightOptions, selectedFlight, isSelectedDateShowing, handleSelectFlight, SP,
}) => (
  <div className={`planePlanTableContainer ${SP ? 'planePlanTableContainerSP' : ''}`}>
    <table>
      <thead>
        <tr>
          <th>選択</th>
          <th>便名</th>
          <th>出発</th>
          <th>到着</th>
          <th>空席</th>
          <th>フライト差額</th>
        </tr>
      </thead>
      <tbody>
        {flightOptions && flightOptions.map((flight, index) => (
          <PlanePlanTableItem
            key={`${tableId}-${flight.id}-${index}`}
            flight={flight}
            tableId={tableId}
            selectedFlight={selectedFlight}
            isSelectedDateShowing={isSelectedDateShowing}
            handleSelectFlight={handleSelectFlight}
          />
        ))}
      </tbody>
    </table>
  </div>
);

PlanePlanTable.propTypes = {
  flightOptions: PropTypes.array.isRequired,
  tableId: PropTypes.string.isRequired,
  selectedFlight: PropTypes.object,
  isSelectedDateShowing: PropTypes.bool.isRequired,
  handleSelectFlight: PropTypes.func.isRequired,
  SP: PropTypes.bool,
};

export default PlanePlanTable;
